import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=b48e4db0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=b48e4db0&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=b48e4db0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48e4db0",
  null
  
)

export default component.exports